'use strict';

module.exports = Backbone.Model.extend({
    defaults: {
        checkinAvailability: {
            available: false,
            requiresAdvancedPassengerInformation: false,
        },
        checkinStatus: {
            checkinAvailable: false,
            checkinStatusBool: false,
        },
    },
    TAB_CONTENT_KEYWORDS: {
        FLIGHT_SUMMARY: 'flightSummary',
        OFFERS_AND_DISCOUNTS: 'offersAndDiscounts',
        CHECK_IN: 'checkIn',
    },
    myBookings: null,
    bookingTripDetails: null,
    countries: {},
    isWithBookings: true,
    isWithPastBookings: true,
    isPrimeUser: false,
    primeExpirationDate: null,
    popUpErrors: {
        'RSA_000': 'deepTokenKoLightbox',
        'TRC_001': 'deepTokenKoLightbox',
        'TRC_002': 'deepTokenKoLightbox',
        'TRC_003': 'deepTokenKoLightbox',
        'TRC_004': 'deepTokenNotOwnerLightbox',
    },
    checkinData: null,
    dataUrl: null,

    url() {
        return Odigeo.Settings.getProperty('serviceUsersFormatter')(this.dataUrl);
    },

    getDataHandler(url, data) {
        this.dataUrl = url;
        return this.fetch(data);
    },
});
